import { useSyncExternalStore } from 'react';

// Unter 768 px, wie Tailwinds `md`. Nur für Komponenten, die am Handy etwas
// anderes rendern statt es per CSS umzustellen (DataTable, Sheet), und für
// Seiten, die am Handy Teure gar nicht erst laden sollen (PM-Kalkulation:
// ohne den Hook käme das Google-Maps-Skript auch am Handy).
const ABFRAGE = '(max-width: 767.98px)';

function abonnieren(melden: () => void) {
  const m = window.matchMedia(ABFRAGE);
  m.addEventListener('change', melden);
  return () => m.removeEventListener('change', melden);
}

/** `true` unter 768 px Breite. Folgt dem Drehen des Geräts und dem Ändern der Fenstergröße. */
export function useMobil() {
  return useSyncExternalStore(
    abonnieren,
    () => window.matchMedia(ABFRAGE).matches,
    () => false,
  );
}
